
/* Rate Right · VER FICHA abre modal. Segunda visita al mismo handle: no reabre, va a comprar. */
(() => {
  const PATH = /^\/products\/[^/?#]+/;
  const motion = matchMedia('(prefers-reduced-motion:no-preference)').matches;
  const tiltOk = matchMedia('(min-width:768px) and (hover:hover) and (pointer:fine)').matches && motion;
  let modal, last, styleEl, giveUp = false;
  const cache = {};
  const seenKey = 'rr_seen_handles';

  function seenSet() {
    try { return new Set(JSON.parse(sessionStorage.getItem(seenKey) || '[]')); }
    catch (_) { return new Set(); }
  }
  function markSeen(handle) {
    const s = seenSet();
    s.add(handle);
    try { sessionStorage.setItem(seenKey, JSON.stringify([...s])); } catch (_) {}
  }
  function handleOf(path) {
    const m = path.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  const css = `
  .rrq{position:fixed;inset:0;z-index:9999;display:none;align-items:flex-start;justify-content:center;overflow-y:auto;overscroll-behavior:contain;background:rgba(5,5,7,.86);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);padding:16px 0}
  .rrq.on{display:flex}
  .rrq-box{position:relative;width:min(1080px,100%);margin:auto;background:#050507;border:1px solid rgba(255,255,255,.15);border-radius:6px}
  .rrq-box .rr{padding-top:8px}
  .rrq-x{position:sticky;top:8px;float:right;margin:8px 8px 0 0;z-index:5;width:44px;height:44px;border-radius:50%;border:1px solid rgba(255,255,255,.2);background:#18181b;color:#fff;font:16px ui-monospace,monospace;cursor:pointer}
  .rrq-full{display:inline-flex;align-items:center;min-height:44px;font:11px ui-monospace,monospace;color:#a1a1aa;text-decoration:none;padding:0 16px}
  .rrq-load{padding:80px 0;text-align:center;font:12px ui-monospace,monospace;color:#a1a1aa}`;

  function build() {
    if (modal) return;
    document.head.insertAdjacentHTML('beforeend', '<style>' + css + '</style>');
    modal = document.createElement('div');
    modal.className = 'rrq';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Ficha del producto');
    modal.innerHTML = '<div class="rrq-box"><button class="rrq-x" type="button" aria-label="Cerrar">✕</button><div class="rrq-body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', e => { if (e.target === modal || e.target.closest('.rrq-x')) close(); });
    document.addEventListener('keydown', e => {
      if (!modal.classList.contains('on')) return;
      if (e.key === 'Escape') close();
    });
    modal.addEventListener('submit', e => {
      const b = e.submitter;
      if (!b || b.name !== 'add' || typeof window.addToCart !== 'function') return;
      e.preventDefault();
      const idEl = e.target.querySelector('[name=id]');
      window.addToCart(idEl ? idEl.value : '', b);
      const h = handleOf(location.pathname) || (last && handleOf(last.getAttribute('href') || ''));
      if (h) markSeen(h);
      relabelTriggers();
      setTimeout(close, 400);
    });
  }

  function tilt(root) {
    const st = root.querySelector('.rr-stage'), bk = root.querySelector('.rr-book');
    if (!st || !bk || !tiltOk) return;
    st.addEventListener('pointermove', e => {
      const r = st.getBoundingClientRect();
      bk.style.setProperty('--ry', ((e.clientX - r.left) / r.width - .5) * 22 + 'deg');
      bk.style.setProperty('--rx', ((e.clientY - r.top) / r.height - .5) * -14 + 'deg');
    });
    st.addEventListener('pointerleave', () => { bk.style.removeProperty('--ry'); bk.style.removeProperty('--rx'); });
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('on');
    document.documentElement.style.overflow = '';
    if (last) last.focus();
  }

  function relabelTriggers() {
    // Keep labels clean and consistent
  }

  async function open(href, trigger) {
    build();
    last = trigger;
    const body = modal.querySelector('.rrq-body');
    body.innerHTML = '<p class="rrq-load">CARGANDO FICHA…</p>';
    modal.classList.add('on');
    modal.scrollTop = 0;
    document.documentElement.style.overflow = 'hidden';
    try {
      const html = cache[href] || (cache[href] = await fetch(href, { credentials: 'same-origin' }).then(r => { if (!r.ok) throw 0; return r.text(); }));
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const main = doc.querySelector('main.rr');
      if (!main) { giveUp = true; throw 0; }
      const st = [...doc.querySelectorAll('style')].find(s => s.textContent.includes('.rr-book'));
      if (!styleEl && st) { styleEl = document.createElement('style'); styleEl.textContent = st.textContent; document.head.appendChild(styleEl); }
      main.querySelector('.rr-top')?.remove();
      body.innerHTML = '';
      body.appendChild(main);
      const bar = document.createElement('div');
      bar.style.cssText = 'display:flex;gap:12px;padding:8px 16px 20px;align-items:center';
      bar.innerHTML = '<button type="button" class="rrq-back" style="min-height:44px;background:none;border:0;color:#ccff00;font:12px ui-monospace,monospace;cursor:pointer;letter-spacing:.08em">← VOLVER AL CATÁLOGO</button>';
      bar.querySelector('.rrq-back').addEventListener('click', function () {
        close();
        const cat = document.getElementById('guias');
        if (cat) cat.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      body.appendChild(bar);
      tilt(body);
      markSeen(handleOf(href));
      relabelTriggers();
    } catch (_) { location.href = href; }
  }

  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a || giveUp || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    if (a.closest('.rrq') || document.querySelector('main.rr')) return;
    let u; try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin || !PATH.test(u.pathname)) return;
    if (u.pathname.indexOf('/cart') === 0) return;
    const dest = u.pathname + u.search;
    const h = handleOf(u.pathname);
    const label = a.textContent.trim();
    if (seenSet().has(h) && (label.indexOf('CHECKOUT') !== -1 || label.indexOf('COMPRAR') !== -1)) {
      return;
    }
    e.preventDefault();
    try { open(dest, a); } catch (_) { location.href = dest; }
  });

  document.querySelectorAll('a[href*="/products/"]').forEach(a => {
    if (a.textContent.trim() === 'VER') a.textContent = 'VER FICHA';
  });
  relabelTriggers();
  tilt(document);
})();